import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { openModal, resetModal } from '../actions/modalsActions';
import { modals } from '../utils/constants';
import ApiClient from '../utils/apiClient';
import i18n from '../utils/i18n';
import Modal from './Modal';

class CancelPremiumModal extends React.Component {
  constructor(props) {
    super(props);

    this.cancelPremium = this.cancelPremium.bind(this);

    this.state = {
      error: false
    };
  }

  cancelPremium() {
    this.setState({ error: false });
    ApiClient.post('/api/v1/cancel-subscription')
      .then(() => {
        this.props.openModal(modals.CANCEL_PREMIUM_SUCCESS_MODAL, {});
      })
      .catch(() => {
        this.setState({ error: true });
      });
  }

  render() {
    return (
      <Modal
        isOpen={true}
        onRequestClose={this.props.resetModal}
        closeButtonText={i18n.t('modals.paymentsCancel.NO')}
        actionButtonText={i18n.t('modals.paymentsCancel.YES')}
        actionFunction={this.cancelPremium}
      >
        <div className="modal-container">
          <h1 className="modal-header">
            {i18n.t('modals.paymentsCancel.ARE_YOU_SURE')}
          </h1>
          <p>
            {i18n.t('modals.paymentsCancel.ALL_YOUR_BOOKINGS_AFTER')}{' '}
            {this.props.modalData.subscriptionEndDate}{' '}
            {i18n.t('modals.paymentsCancel.WILL_BE_CANCELLED')}
          </p>
          <p>{i18n.t('modals.paymentsCancel.ANY_QUESTIONS_CONCERNS')}</p>
          <p className="error-message-wrapper">
            {this.state.error &&
              i18n.t('modals.paymentsCancel.SOMETHING_WENT_WRONG')}
          </p>
        </div>
      </Modal>
    );
  }
}

CancelPremiumModal.propTypes = {
  openModal: PropTypes.func.isRequired,
  resetModal: PropTypes.func.isRequired,
  modalData: PropTypes.shape({
    subscriptionEndDate: PropTypes.string
  })
};

CancelPremiumModal.defaultProps = {
  modalData: {
    subscriptionEndDate: ''
  }
};

const mapStateToProps = state => ({
  modalData: state.modals.modalData
});

const mapDispatchToProps = dispatch => ({
  dispatch,
  resetModal: () => dispatch(resetModal()),
  openModal: (modal, modalData) => dispatch(openModal(modal, modalData))
});

export default connect(mapStateToProps, mapDispatchToProps)(CancelPremiumModal);



// WEBPACK FOOTER //
// ./src/modals/CancelPremiumModal.js